import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    // CSRF protection: forces a CORS preflight for any cross-origin JS,
    // which our CORS allowlist will reject → blocks cross-site forgery.
    "X-Requested-With": "XMLHttpRequest",
  },
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const BRAND = {
  name: "Dr Thrive 365",
  short: "Dr Thrive 365",
  tagline: "Rewire Your Biology. Restore Your Energy. Step Into Purpose.",
  domain: "drthrive365.com",
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_wellness-vault-24/artifacts/6xx58yfa_image.png",
};

// Fallback used before the /api/tiers fetch completes — keeps SSR/first paint crisp.
// The live list is always fetched from the backend via useTiers().
// Each tier exposes BOTH `tier_key` (canonical, matches backend) and `key` (legacy alias).
const _mk = (t) => ({ ...t, key: t.tier_key });
export const DEFAULT_TIERS = [
  _mk({
    tier_key: "workshop",
    name: "Peptide Protocol Workshop",
    price: "$147",
    cadence: "one-time",
    sub: "Your entry into bio-optimization.",
    features: [
      "5 core peptide lessons",
      "Daily integration playbook",
      "Downloadable protocol PDFs",
      "30 days of daily protocols",
    ],
    grants_tier: "workshop",
  }),
  _mk({
    tier_key: "course",
    name: "Hormone Reset Mini-Course",
    price: "$247",
    cadence: "one-time",
    sub: "Regulate cortisol, estrogen, testosterone.",
    features: [
      "Everything in Workshop",
      "9 hormone lessons",
      "Cycle-synced training guide",
      "Mitochondria & recovery deep dive",
    ],
    grants_tier: "course",
  }),
  _mk({
    tier_key: "membership",
    name: "Dr Thrive 365 Membership",
    price: "$67",
    cadence: "per month",
    sub: "Rewire biology. Every day. Together.",
    features: [
      "Everything in Workshop + Course",
      "Neuroplasticity + Faith library",
      "Weekly drip content",
      "Private community",
      "Monthly Q&A with Dr. Slava",
    ],
    popular: true,
    grants_tier: "membership",
  }),
  _mk({
    tier_key: "cohort",
    name: "8-Week Cohort Program",
    price: "$1,997",
    cadence: "one-time",
    sub: "High-touch transformation.",
    features: [
      "Everything in Membership",
      "8 weekly live sessions",
      "1:1 intake call",
      "Cohort accountability",
      "Lifetime replay access",
    ],
    grants_tier: "cohort",
  }),
];

// Legacy export — kept so older imports still work; prefer useTiers() going forward.
export const TIERS = DEFAULT_TIERS;

export const TIER_ORDER = { free: 0, workshop: 1, course: 2, membership: 3, cohort: 4 };

export function canAccess(userTier, required) {
  return (TIER_ORDER[userTier] ?? 0) >= (TIER_ORDER[required] ?? 0);
}

export const CATEGORIES = [
  { key: "peptides", label: "Peptides", accent: "#FF8A00" },
  { key: "hormones", label: "Hormones", accent: "#E52E71" },
  { key: "neuroplasticity", label: "Neuroplasticity", accent: "#FFB347" },
  { key: "faith", label: "Faith & Mindset", accent: "#FFD58A" },
];
